import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as rostersActions from 'features/rosters/duck';
import * as staticActions from 'shared/ducks/staticDuck';
import { ModalInfo, Spinner } from 'shared/components';
import AccomodationIcon from 'assets/svgs/accomodationIconBlack.svg';
import StandByIcon from 'assets/svgs/standbyIconBlack.svg';
import LeftHandedIcon from 'assets/svgs/leftHandedIconBlack.svg';
import OnlineIcon from 'assets/svgs/onlineIconBlack.svg';
import NoPhoto from 'assets/svgs/noPhoto.svg';
import { isEmpty, isNull, isUndefined, join, map } from 'lodash';
import { REGISTRATION_TYPES } from 'shared/constants';

import './ExamineeDetails.scss';

class ExamineeDetails extends Component {
  constructor(props) {
    super(props);

    this.state = {
      examineeDetailsModalOpen: false,
    };

    this.showExamineeDetails = this.showExamineeDetails.bind(this);
    this.closeExamineeDetails = this.closeExamineeDetails.bind(this);
  }

  showExamineeDetails(examineeId) {
    const { examinee } = this.props;
    if (examinee.id !== examineeId) {
      this.props.actions.getExamineePhoto(examineeId);
    }
    this.props.actions.getExamineeDetails(examineeId).then(() => {
      this.setState({
        examineeDetailsModalOpen: true,
      });
    });
  }

  closeExamineeDetails() {
    this.setState({
      examineeDetailsModalOpen: false,
    });
  }

  render() {
    const { examinee, examineePhoto, examineePhotoLoading } = this.props;
    const { examineeDetailsModalOpen } = this.state;

    return (
      <div>
        <ModalInfo
          containerClass="examinee-details-modal-container"
          onSubmit={this.closeExamineeDetails}
          closeModal={this.closeExamineeDetails}
          modalIsOpen={examineeDetailsModalOpen}
          headerTitle="rosters.examineeModal.header"
          saveLabel="common.labels.back"
          className="examinee-details-modal">
          <React.Fragment>
            <div className="image-container">
              {examineePhotoLoading ? (
                <Spinner />
              ) : examineePhoto ? (
                <img
                  src={`data:image/png;base64,${btoa(
                    new Uint8Array(examineePhoto).reduce(
                      (data, byte) => data + String.fromCharCode(byte),
                      ''
                    )
                  )}`}
                />
              ) : (
                <NoPhoto />
              )}
            </div>
            <div className="details-section">
              <div className="header-section">
                <h4 className="">
                  <span>
                    {examinee.lastName}, {examinee.firstName} {examinee.middleName}{' '}
                  </span>
                  {examinee.standbyFlag && (
                    <span className="icons d-inline-block">
                      <StandByIcon />
                    </span>
                  )}
                  {examinee.onlineFlag && (
                    <span className="icons d-inline-block">
                      <OnlineIcon />
                    </span>
                  )}
                  {examinee.accomRosterFlag && (
                    <span className="icons d-inline-block">
                      <AccomodationIcon />
                    </span>
                  )}
                  {examinee.leftHandedFlag && (
                    <span className="icons d-inline-block">
                      <LeftHandedIcon />
                    </span>
                  )}
                </h4>
                <div className=" dark-gray fw-bold">
                  {!isNull(examinee.roomName) && !isUndefined(examinee.roomName)
                    ? examinee.roomName
                    : this.props.t('common.labels.notAssigned')}
                </div>
                <div className="examinee-type-timing dark-gray font-size-12">
                  <div className="">{examinee.regType}</div>
                  {examinee.timing && <div className="text-capitalize">{examinee.timing}</div>}
                  <div>
                    {examinee.onlineFlag
                      ? this.props.t('common.labels.online')
                      : this.props.t('common.labels.paper')}
                  </div>
                </div>
              </div>
              <div className="columns-section dark-gray">
                {examinee.capacityType === REGISTRATION_TYPES.sectionRetest && (
                  <div>
                    <div>{this.props.t('rosters.retestLabel')}</div>
                    <div>{examinee.sectionList}</div>
                  </div>
                )}
                <div className="">
                  <div>{this.props.t('common.labels.gender')}</div>
                  <div>{examinee.gender}</div>
                </div>
                <div className="">
                  <div>{this.props.t('rosters.tableHeaders.hsCode')}</div>
                  <div>{examinee.highSchoolCode}</div>
                </div>
                <div className="">
                  <div>{this.props.t('rosters.tableHeaders.matchID')} </div>
                  <div>{examinee.matchId}</div>
                </div>
                <div className="">
                  <div>
                    {this.props.t('common.labels.city')}
                    <span className="text-lowercase">
                      , {this.props.t('common.labels.state')}
                    </span>{' '}
                  </div>
                  <div>
                    {examinee.city}, {examinee.state}
                  </div>
                </div>
                {!isEmpty(examinee.accommodations) && (
                  <div className="">
                    <div>{this.props.t('rosters.tableHeaders.accom')}</div>
                    <div>{join(map(examinee.accommodations, 'name'), ', ')}</div>
                  </div>
                )}
              </div>
            </div>
          </React.Fragment>
        </ModalInfo>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    examinee: state.rosters.currentExaminee,
    examineePhoto: state.rosters.currentExamineePhoto,
    examineePhotoLoading: state.rosters.examineePhotoLoading,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...rostersActions,
        ...staticActions,
      },
      dispatch
    ),
  };
}

export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(ExamineeDetails)
);

ExamineeDetails.propTypes = {
  t: PropTypes.func.isRequired,
  examinee: PropTypes.shape({
    id: PropTypes.number,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    middleName: PropTypes.string,
    standbyFlag: PropTypes.bool,
    onlineFlag: PropTypes.bool,
    accomRosterFlag: PropTypes.bool,
    leftHandedFlag: PropTypes.bool,
    roomName: PropTypes.string,
    capacityType: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    accommodations: PropTypes.array,
  }),
  examineePhoto: PropTypes.any,
  examineePhotoLoading: PropTypes.bool,
  actions: PropTypes.shape({
    getExamineePhoto: PropTypes.func,
    getExamineeDetails: PropTypes.func,
  }),
};
